/* @flow */
import * as React from 'react';
import { IndexRoute, Route } from 'react-router';

import JoinInfoPageBirthdate from 'join/components/JoinInfoPageBirthdate.jsx';
import SetupAdminRole from './components/SetupAdminRole.jsx';
import SetupFullName from './components/SetupFullName.jsx';
import SetupGroup from './components/SetupGroup.jsx';
import SetupSchool from './components/SetupSchool.jsx';
import SetupView from './components/SetupView.jsx';
import SetupSmsDevice from './components/SetupSmsDevice.jsx';
import SetupSignature from './components/SetupSignature.jsx';
import SetupEmail from './components/SetupEmail.jsx';
import SetupPIIConsent from './components/SetupPIIConsent.jsx';
import SetupPassword from './components/SetupPassword.jsx';
import SetupSubscription from './components/SetupSubscription.jsx';
import SetupSchoolEmail from './components/SetupSchoolEmail.jsx';
import SetupRosterAll from './components/SetupRosterAll.jsx';
import SetupRosterConfirm from './components/SetupRosterConfirm.jsx';
import SetupRosterChoose from './components/SetupRosterChoose.jsx';
import MarketingLayout from 'components/MarketingLayout.jsx';
import SetupRole from './components/SetupRole.jsx';

import RequireSetup from 'lib/RequireSetup';
import RequireUser from 'lib/RequireUser';

export default (
  <Route>
    <Route component={MarketingLayout}>
      <Route path="/setup(/)" component={SetupView} onEnter={RequireUser}>
        <Route path="/setup/roster/choose" component={SetupRosterChoose} />
        <Route path="/setup/role" component={SetupRole} />
        <Route path="/setup/pii" component={SetupPIIConsent} />
        <Route path="/setup/class" component={SetupGroup} />
        <Route path="/setup/school" component={SetupSchool} />
        <Route path="/setup/signature" component={SetupSignature} onEnter={RequireUser} />
        <Route path="/setup/name" component={SetupFullName} onEnter={RequireUser} />
        <Route path="/setup/device/sms" component={SetupSmsDevice} onEnter={RequireUser} />
        <Route path="/setup/subscriptions" component={SetupSubscription} onEnter={RequireUser} />
        <Route path="/setup/password" component={SetupPassword} onEnter={RequireUser} />
        <Route path="/setup/email" component={SetupEmail} onEnter={RequireUser} />
        <Route path="/setup/admin_role" component={SetupAdminRole} onEnter={RequireUser} />
        <Route path="/setup/roster/all" component={SetupRosterAll} />
        <Route path="/setup/roster/confirm" component={SetupRosterConfirm} />
        <Route path="/setup/school_email" component={SetupSchoolEmail} />
        <Route path="/setup/birthdate" component={JoinInfoPageBirthdate} onEnter={RequireUser} />

        <IndexRoute onEnter={RequireSetup} />
      </Route>
    </Route>
  </Route>
);
